{
  "ancillaries": {
    "bundle": {
      "seatMapToggle": {
        "includedSeat": "This combo includes {seatType} seat {seatNumber}.",
        "incompatibleSeat": "This combo isn’t available for your complimentary {seatType} seat {seatNumber}. Please select another seat type to add the combo.",
        "showSeatMap": "Show seat map"
      }
    }
  },
  "purchase": {
    "success": {
      "alternateCtaButton": "View your booking and add travel extras"
    }
  }
}
